import { useEffect, useState } from 'react'
import { ANEX } from '@anex/common'
import { createFileRoute } from '@tanstack/react-router'
import { observer } from 'mobx-react'

import { useRootStore } from '~/store/RootStore'
import { checkMfaBeforeLoad } from '~/utils/beforeLoad'

import { Card, ContentWrapper, H5 } from '~/components/elements'
import Loading from '~/components/loading'
import { CreditCardForm } from '~/components/billing/CreditCardForm'
import { QuickStreamForm } from '~/components/billing/QuickStreamForm'
import { IGatewayTypes } from '~/types'

const PaymentDetailsPage = observer(() => {
  const { billing } = useRootStore()
  const paymentMethods = billing.getPaymentMethods

  const [paymentMethod, setPaymentMethod] =
    useState<ANEX.Website.API.Endpoints.V1.Lookup.Payment.AvailablePaymentMethods.PaymentMethod | null>(
      null
    )

  useEffect(() => {
    if (paymentMethods && paymentMethods.length === 0) {
      // fetch again the available payment methods if
      // we don't have any in the billing store
      billing.getAvailablePaymentMethods()
    } else {
      setPaymentMethod(paymentMethods[0])
    }
  }, [paymentMethods])

  return (
    <ContentWrapper>
      <Card style={{ width: '100%', maxWidth: '650px', margin: 'auto' }}>
        <H5>Update Payment Details</H5>
        {!paymentMethod && <Loading iconwidth="100px" />}
        {paymentMethod &&
          paymentMethod?.gatewayType?.toLowerCase() === 'eway' && (
            <CreditCardForm />
          )}
        {paymentMethod &&
          paymentMethod?.gatewayType?.toLowerCase() === 'quickstream' && (
            <QuickStreamForm
              config={paymentMethod}
              paymentGateway={
                (paymentMethod.gatewayType as IGatewayTypes) || 'QuickStream'
              }
            />
          )}
      </Card>
    </ContentWrapper>
  )
})

export const Route = createFileRoute('/_authenticated/billing/payment-details')(
  {
    beforeLoad: checkMfaBeforeLoad,
    component: PaymentDetailsPage,
  }
)
